import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-groups-settings',
  templateUrl: './user-groups-settings.component.html',
  styleUrls: ['./user-groups-settings.component.scss']
})
export class UserGroupsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
